/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetTotalCountOpenUrlaubsantraege$Plain$Params {

/**
 * Name der Units optional
 */
  units?: Array<string>;
}

export function getTotalCountOpenUrlaubsantraege$Plain(http: HttpClient, rootUrl: string, params?: GetTotalCountOpenUrlaubsantraege$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, getTotalCountOpenUrlaubsantraege$Plain.PATH, 'get');
  if (params) {
    rb.query('units', params.units, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

getTotalCountOpenUrlaubsantraege$Plain.PATH = '/v1/urlaubsantraege/open';
